var _style, _defs, _path, _path2, _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQ4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000156576032453254409380000005267984377655156113_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 155.1 155.3",
    style: {
      enableBackground: "new 0 0 155.1 155.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000055697057418171646780000017982762938972585377_);}\n\t.st1{fill:#36A7DC;}\n\t.st2{fill:#F4AC74;}\n\t.st3{fill:#50A2CA;}\n\t.st4{fill:#83C5BF;}\n\t.st5{fill:#EEC098;}\n\t.st6{fill:#F7CFAC;}\n\t.st7{fill:#E4E4E5;}\n\t.st8{fill:#60909C;}\n\t.st9{fill:#7C4F48;}\n\t.st10{fill:none;stroke:#002A33;stroke-width:8;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 78.3,
    cy: 77.1,
    r: 71.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000010299755266549843770000013220825207342736032_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000010299755266549843770000013220825207342736032_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.6,156L149.6,156c2.7,0,5.4,0,8.1,0c1.5,0,2.6-0.7,3.1-2.2c0.4-1.5-0.4-2.4-1.5-3.3 c-0.4-0.3-0.9-0.9-1-1.4c-0.6-2.2-2.1-3.3-4.3-2.9c-0.9,0.2-1.4,0.1-2.1-0.7c-2.9-3.3-7.6-2.4-9.2,1.8c-0.2,0.4-0.7,0.9-1.1,1 c-2.7,0.4-4.2,1.8-4.1,3.9c0.1,2.3,1.8,3.7,4.5,3.7C144.6,156.1,147.1,156,149.6,156L149.6,156z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.9,117.5c-0.2-0.1-0.5-0.3-0.8-0.4c0.3-0.1,0.6-0.2,0.8-0.3C11.9,117,11.9,117.3,11.9,117.5L11.9,117.5z "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3.2,
    className: "st3",
    width: 153.9,
    height: 146
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M12.8,134.5l-3.3,109h18.2l6.7-100.9c4.5,26.7,5.8,58.6,4.3,92.4h77.7c-1.6-34.6,0-62,4.7-92.6l6.9,101.2 h18.2l-3.3-109c0-13.6-9.4-25.4-22.7-28.3L77.8,95.3l-42.3,10.9C22.2,109.2,12.8,120.9,12.8,134.5L12.8,134.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "61,70.3 94.6,70.3 94.6,100.5 77.8,111 61,100.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M77.8,26.9L77.8,26.9c13.8,0,25,11.2,25,25v22.2c0,5.5-2.5,10.8-6.8,14.3l-9.5,7.8 c-5.1,4.2-12.5,4.2-17.6,0l-9.5-7.8c-4.3-3.5-6.8-8.8-6.8-14.3V52C52.8,38.1,64,26.9,77.8,26.9L77.8,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M77.8,20.8c-16.9,0-28.8,14.8-26.9,30.9l1.9,16.1l0,0c1.6,0,2.9-1.3,2.9-2.9v-7.5 c0-4.6,25.9-8.2,32.4-10.1l6.5-1.9l0.1,0.1c2.9,3,4.6,7,4.6,11.2V65c0,1.6,1.3,2.9,2.9,2.9h0.7l1.9-16.1 C106.6,35.7,94.7,20.8,77.8,20.8L77.8,20.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "77.8,111.9 87.3,123.9 77.8,118 68.4,123.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M83.5,119.4l-5.3-7.6l-5.3,7.6C76.3,124.3,79.8,124.4,83.5,119.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M75.8,120.3h5.2l7.8,53l-0.8,0.1c-6.4,1-14,0.9-20.2-0.1l0,0C67.8,173.3,75.8,120.3,75.8,120.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M105.2,62.4H50v3.4h3.1l1.1,5.2c0.7,3.2,3.6,5.5,6.9,5.5h5.4c3.6,0,6.8-2.5,7.5-6.1l1-4.6h4.9l1,4.6 c0.8,3.6,3.9,6.1,7.5,6.1h5.4c3.3,0,6.2-2.3,6.9-5.5l1.1-5.2h3.3C105.2,65.8,105.2,62.4,105.2,62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M88.4,73.5c-2.2,0-4.1-1.6-4.6-3.7L83,65.5h15.8l-1.1,4.9c-0.4,1.8-2,3.1-3.9,3.1H88.4z M61.1,73.5 c-1.8,0-3.5-1.3-3.9-3.1l-1.1-4.9H72L71,69.8c-0.5,2.1-2.4,3.7-4.6,3.7C66.5,73.5,61.1,73.5,61.1,73.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M83.2,53.2c0,0,0.2-0.2,0.3-0.4c0.2-0.3,0.4-0.7,0.7-1.2c0.6-1.2,1.5-3,2.2-4.6c0.7-1.6,1.1-3.2,1.1-4.2 c0.1-1,0-1.7,0-1.7c-0.5-2.4,1-4.8,3.4-5.3s4.8,1,5.3,3.4c0.1,0.5,0.1,1,0.1,1.4l-0.1,1c0,0-0.2,1.4-0.8,3.1 c-0.7,1.8-1.8,3.8-3.1,5.5c-1.3,1.8-2.6,3.2-3.7,4.3c-0.5,0.6-1.1,1.1-1.5,1.5c-0.4,0.4-0.7,0.5-0.7,0.5 c-0.9,0.8-2.4,0.8-3.3-0.2C82.2,55.6,82.3,54.1,83.2,53.2L83.2,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M73.2,54c0,0,0.2-0.1,0.4-0.3c0.2-0.2,0.6-0.5,1-1c0.9-1,2.2-2.5,3.3-3.9c1.1-1.4,1.9-2.9,2.3-3.9 c0.4-1,0.5-1.7,0.5-1.7c0.2-1.9,1.9-3.2,3.7-3c1.9,0.2,3.2,1.9,3,3.7c0,0.2-0.1,0.4-0.1,0.5l-0.1,0.5c0,0-0.3,1.2-1.2,2.8 c-0.9,1.6-2.3,3.4-3.8,4.9c-1.5,1.5-3,2.7-4.2,3.8c-0.6,0.5-1.2,1-1.7,1.3c-0.5,0.3-0.8,0.4-0.7,0.4c-1.1,0.7-2.5,0.3-3.2-0.8 C71.7,56.1,72.1,54.6,73.2,54L73.2,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M64,54.2c0,0,0.7-0.7,1.8-1.8c1.1-1.1,2.6-2.5,3.7-3.8c1.2-1.4,1.8-2.8,2.1-3.7c0.3-1,0.2-1.5,0.2-1.5 c-0.3-2.3,1.3-4.3,3.5-4.7s4.3,1.3,4.7,3.5c0.1,0.5,0.1,0.9,0,1.3l-0.2,1.1c0,0-0.3,1.5-1.3,3.3c-1,1.8-2.7,3.8-4.6,5.2 c-1.8,1.4-3.6,2.5-4.9,3.3c-1.3,0.8-2.2,1.4-2.2,1.4c-1.1,0.7-2.5,0.4-3.2-0.7C63,56.1,63.2,54.9,64,54.2L64,54.2z"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 77.4,
    cy: 77.4,
    r: 73.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ4);
export default __webpack_public_path__ + "static/media/q4.65d50839f9b25d663bcd5fb70a06195a.svg";
export { ForwardRef as ReactComponent };